import { useTranslation } from 'react-i18next';
import { Field, Label, Select, ValidationMessage } from '@digdir/designsystemet-react';
import { FC } from 'react';

import { TilliggendeRom } from '../../../../../../components/registering/utils/registerEnums';
import { useOmBoligenFormContext } from '../utils';

interface OptionProps {
  type: TilliggendeRom;
}

const TilliggendeRomOption: FC<OptionProps> = ({ type }) => {
  const { t } = useTranslation();
  return <Select.Option value={type}>{t(`register.adjoiningRooms.option.${type}`)}</Select.Option>;
};

export const TilliggendeRomSelect = () => {
  const { t } = useTranslation();
  const { register, formState } = useOmBoligenFormContext();

  const error = formState.errors.bygginfo?.basementAdjoiningRoom?.message;

  return (
    <Field>
      <Label>{t('register.bygningsdetaljer.tilliggendeRomGulvIForsteEtasje.label')}</Label>
      <Select
        aria-invalid={!!error}
        {...register('bygginfo.basementAdjoiningRoom', {
          required: t('register.adjoiningRooms.option.defaultFirstStoryFloor'),
          shouldUnregister: true
        })}
        defaultValue=""
        width="full"
      >
        <Select.Option disabled value="">
          {t('register.adjoiningRooms.option.defaultFirstStoryFloor')}
        </Select.Option>
        <TilliggendeRomOption type={TilliggendeRom.MotDetFri} />
        <TilliggendeRomOption type={TilliggendeRom.MotGrunn} />
        <TilliggendeRomOption type={TilliggendeRom.OppvarmetRom} />
        <TilliggendeRomOption type={TilliggendeRom.UoppvarmetRom} />
        <TilliggendeRomOption type={TilliggendeRom.Krypkjeller} />
        <TilliggendeRomOption type={TilliggendeRom.Ukjent} />
      </Select>
      {error && <ValidationMessage data-color="danger">{error}</ValidationMessage>}
    </Field>
  );
};
